import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { ExamenScene } from 'scenes';

class ExamenContainer extends AbstractContainer {

  getTasks(params) {

    let examen = params.examen;

    return [
      {
        key: 'examen',
        exec: (done, failure) => {
          API.get(`examens/${examen}`)
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {
    return <ExamenScene examen={results.examen} />
  }
}

export default ExamenContainer;
